import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import { auth } from "config/firebase";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, Link } from "react-router-dom";
import { Fab, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { displaySnackBar } from "store/SnackBar";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(2),
    },
    "& p": {
      position: "absolute",
      top: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      "& > *": {
        margin: theme.spacing(2),
        width: 300,
      },
    },
    root: {
      "& > *": {
        margin: theme.spacing(2),
      },
    },
  },
  heading: {
    fontFamily: "Poppins",
    textAlign: "center",
  },
}));

const signInSchema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: yup.string().required("Password is required"),
});

const SignUp = () => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm({
    validateCriteriaMode: "all",
    validationSchema: signInSchema,
    validationSchemaOption: {
      abortEarly: false,
    },
  });
  const onSubmit = async (data) => {
    try {
      const cred = await auth.createUserWithEmailAndPassword(
        data.email,
        data.password
      );
      dispatch(
        displaySnackBar({
          severity: "success",
          message: "Signed Up successfully",
        })
      );
      cred?.user ? push("/") : push("/signin");
    } catch (error) {
      dispatch(displaySnackBar({ severity: "error", message: error.message }));
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <h2 className={classes.heading}>Register</h2>
      <form
        method="POST"
        onSubmit={handleSubmit(onSubmit)}
        className={classes.paper}
      >
        <TextField
          error={errors?.email ? true : false}
          helperText={errors.email?.message}
          name="email"
          variant="outlined"
          fullWidth
          id="email"
          label="Email"
          autoFocus
          inputRef={register}
        />
        <TextField
          error={errors?.password ? true : false}
          helperText={errors?.password?.message}
          name="password"
          variant="outlined"
          fullWidth
          id="password"
          type="password"
          label="Password"
          autoFocus
          inputRef={register}
        />

        <Fab
          type="submit"
          variant="extended"
          color="primary"
          style={{ margin: "10px" }}
        >
          Sign In
        </Fab>
      </form>
      <Typography>
        Already have an account? <Link to="/signin">Sign In here</Link>
      </Typography>
    </Container>
  );
};
export default SignUp;
